export default {
  navbar: {
    favorite: 'Favorite',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    signInModel: 'Sign In',
    signOutModel: 'Sign Out',
  },
  hero: {
    title: 'Impression of Taipei',
    search: 'Do you want to go?',
    date: 'Date',
    MRT: 'MRT Station',
    searchBtn: 'Search',
    advancedSearchBtn: 'Advance',
    district: 'District',
    themed: 'Themed Attractions',
    searchAdvancedClearBtn: 'Clear All',
    searchAdvancedSerchBtn: 'Search',
  },
  contentSection: {
    title: 'Taipei Attractions List',
    mostScore: 'Most Rated',
    mostComment: 'Most comments',
    searchNothing: 'Attractions Not Found',
  },
  card: {
    detailsBtn: 'Details',
    openAllDay: 'Open all day',
  },
  model: {
    signInTitle: 'Sign In',
    signUpTitle: 'Sign Up',
    signInSubTitle: 'Collection of attractions, starting from login',
    signUpSubTitle: 'Start collecting attractions after registration',
    emailInput: 'Enter your email',
    passwordInput: 'Enter your password',
    googleSignIn: 'Sign in with Google',
    googleSignInBtn: 'Sign in with your Google Account',
    nickNameInput: 'Please enter a nickname',
    checkPasswordInput: 'confirm password',
  },
  remindModel: {
    btn: 'Confirm',
    signInRemind: 'Please login first',
  },
  attractionPage: {
    infoTitle: 'Attractions information',
    tag: 'Themed',
    category: 'Subject',
    address: 'Address',
    month: 'Suggested Months',
    web: 'Official Website',
    tel: 'Phone Number',
    openTime: 'Opening Hours',
    service: 'Services',
    mrt: 'Nearby MRT',
    traffic: 'Transportaiton',
    trafficContentText: 'Choose a transportation method',
    openRemind: 'Open Time',
    Remind: 'Reminder',
    mapTitle: 'Attractions map',
    messageTitle: 'Attractions Reviews',
    nearbyAttractions: 'Recommended nearby attractions',
    ticket: 'Ticket information',
    cancelMessage: 'Cancel',
    leaveComments: 'Leave Comments',
    sendMessage: 'Send',
  },
  footer: {
    address: '4F., No. 1, Shifu Rd., Xinyi Dist., Taipei City 110, Taiwan (R.O.C.)',
    tel: 'Phone : 02-27208889',
    serviceTime: 'Service Hours : Monday to Friday: 08:30-12:30 13:30-17:30',
  },
  favoritePage: {
    title: 'Member Centre',
    subTitle: 'My favorite spots',
    tagTheme: [
      "SPA",
      "Cycling",
      "Historic Buildings",
      "Faith",
      "Art Gallery",
      "Public Art",
      "Bule Highway",
      "Family Activities",
      "Outdoor Walking",
    ],
  },
  editor: {
    title: 'Give a rating',
    placeholder: 'Write a review!',
    editMessage: 'Edit',
    deleteMessage: 'Delete'
  }
}